import { ITransshipment, TTransshipmentStepId } from '../../types';

export const rg = {
  path: 'documentos/frente-identidade',
  next: (trans: ITransshipment): TTransshipmentStepId => {
    if (trans.data.status !== 'retake-documents') {
      return 'selfie-page';
    }

    if (
      trans.data.documents.some(
        (doc) => doc.category === 'selfie' && doc.status === 'invalid'
      )
    ) {
      return 'selfie-page';
    }

    return trans.type === 'representative'
      ? 'documents-success-page'
      : 'success-page';
  },
};

export default rg;
